/** Stay under nginx's default 1 MB body limit, including the multipart wrapper. */
const BANK_STATEMENT_CHUNK_SIZE = 800 * 1024;

function bankStatementChunkPlan(size, chunkSize = BANK_STATEMENT_CHUNK_SIZE) {
  const bytes = Number(size) || 0;
  if (bytes <= 0) return [];
  const ranges = [];
  for (let start = 0; start < bytes; start += chunkSize) {
    ranges.push({
      index: ranges.length,
      start,
      end: Math.min(start + chunkSize, bytes),
    });
  }
  return ranges;
}

function bankStatementNeedsChunks(size, chunkSize = BANK_STATEMENT_CHUNK_SIZE) {
  return bankStatementChunkPlan(size, chunkSize).length > 1;
}

module.exports = {
  BANK_STATEMENT_CHUNK_SIZE,
  bankStatementChunkPlan,
  bankStatementNeedsChunks,
};
